export const CATEGORY_RELEVANCY: string = "Category Relevancy";
export const RAW: string = "Raw";
export const CURATED: string = "Curated";
export const CLEAR_ALL: string = "Clear All";
export const CATEGORY: string = "Category";
export const CATEGORY_TYPE: string = "Category Type";
export const CO_SOLD_CATEGORY: string = "Co-sold Category";
export const CO_SOLD_CATEGORY_TYPE: string = "Co-sold Category Type";
export const INVOICE_COUNT: string = "Invoice Count";
export const LOADING: string = "Loading...";
export const NO_CATEGORIES_FOUND: string = "No categories found";
export const NO_CO_SOLD_CATEGORIES_FOUND: string = "No co-sold categories found";